import { QueryKeys } from '../../../queryKeys';
import apiRoutes from '../../../api-routes';

import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

import { getRequest } from '../../../helpers/apiClient';

export const useCurrentUser = (options) =>
  useQueryWithLogout(
    [QueryKeys.ME],
    async () => {
      const { data } = await getRequest({
        url: apiRoutes.ME,
      });
      return data;
    },
    options,
  );
